import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-verify-ip-address',
  templateUrl: './verify-ip-address.component.html',
  styleUrls: ['./verify-ip-address.component.scss']
})
export class VerifyIpAddressComponent implements OnInit {

  ngOnInit() {
  }
}
